import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventLabel, GATrackingEventType } from '../../constants';
import { BannerInteractionEventType } from '~shared/modules/application-event/constants';

export class GATrackingBannerEvent implements GATrackingEvent {

  constructor(private payload: {type: BannerInteractionEventType, banner: any}) {

  }

  getEventType(): GATrackingEventType {
    return this.payload.type === 
    BannerInteractionEventType.BannerClick ? GATrackingEventType.BannerClick : GATrackingEventType.PromoView;
  }

  getEventName(): string {
      return this.payload.type === BannerInteractionEventType.BannerClick ? 'promoClick' : 'promoView';
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.getEventName(),
      label: GaTrackingEventLabel.TopBanners,
      gtmCustom: this.payload.banner
    };
  }
}
